import { format } from 'date-fns'

export function formatDate(date: Date | string) {
	if (typeof date === 'string') {
		return format(new Date(date), 'dd/MM/yyyy')
	} else {
		return format(date, 'dd/MM/yyyy')
	}
}

export function parseDate(date: string) {
	if (date.includes('/')) {
		let [day, month, year] = date.split('/').map(s => s.trim())
		if (!year || !month || !day) return 'Sin fecha'
		return new Date(parseInt(year), parseInt(month) - 1, parseInt(day))
	}
	return new Date(date)
}

export function formatDateLong(date: Date | string) {
	try {
		if (typeof date === 'string') {
			const trimmed = date.trim()
			const ymdMatch = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})$/)
			if (ymdMatch) {
				const [, year, month, day] = ymdMatch
				date = new Date(Number(year), Number(month) - 1, Number(day))
			}
		}
		// accept strings with 13/02/2023 format, where the month is 2 digits
		if (typeof date === 'string' && date.includes('/')) {
			let [day, month, year] = date.split('/').map(s => s.trim())
			if (!year || !month || !day) return 'Sin fecha'
			date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day))
		}
		// in spanish like 1 de agosto de 2022
		return new Date(date).toLocaleDateString('es-ES', {
			month: 'long',
			day: 'numeric',
			year: 'numeric',
		})
	} catch (error) {
		return 'Sin fecha'
	}
}

export function formateLongDatetime(date: Date | string) {
	try {
		// accept strings with 13/02/2023
		return new Date(date).toLocaleString('es-ES', {
			year: 'numeric',
			month: 'long',
			day: 'numeric',
			hour: 'numeric',
			minute: 'numeric',
			second: 'numeric',
			hour12: true,
		})
	} catch (error) {
		return 'Sin fecha'
	}
}
